import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["image", "altText", "className", "content", "children", "textAlign", "verticalAlign", "disabled", "imageProps"];
import React from 'react';
import { getContentStyle } from './FullImageCard.utils';
import { ImagePropType, ObjectPropsPropType } from '../../../../../../services/proptypes';
import { classNames } from '../../../../../../utils/classname';
import { withEvent } from '../../../../../analytics/components/Event';
import useSemanticUiProps from '../../../../../foundation/hooks/use-semantic-ui-props';
import { ChildrenPropType } from '../../../../../foundation/types/component';
import ImageCard from '../../ImageCard';
import './FullImageCard.less';
var defaultProps = {
  image: null,
  altText: '',
  className: '',
  content: null,
  children: null,
  textAlign: 'center',
  verticalAlign: 'middle',
  disabled: false,
  imageProps: {}
};
function FullImageCard(_ref) {
  var image = _ref.image,
    altText = _ref.altText,
    className = _ref.className,
    content = _ref.content,
    children = _ref.children,
    textAlign = _ref.textAlign,
    verticalAlign = _ref.verticalAlign,
    disabled = _ref.disabled,
    imageProps = _ref.imageProps,
    cardProps = _objectWithoutProperties(_ref, _excluded);
  var _useSemanticUiProps = useSemanticUiProps(),
    getCardProps = _useSemanticUiProps.getCardProps;
  var finalContent = content || children;
  var finalClassName = classNames(_defineProperty({
    'full-image-card': true
  }, className, className));
  var contentStyle = getContentStyle(textAlign, verticalAlign);
  var finalCardProps = getCardProps(cardProps);
  return /*#__PURE__*/React.createElement(ImageCard, _extends({
    className: finalClassName,
    disabled: disabled
  }, finalCardProps), /*#__PURE__*/React.createElement(ImageCard.Image, _extends({
    src: image,
    background: true,
    altText: altText
  }, imageProps || {}), /*#__PURE__*/React.createElement(ImageCard.Content, {
    style: contentStyle
  }, finalContent)));
}
FullImageCard.defaultProps = defaultProps;
export default withEvent('click')(FullImageCard);